import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, InstagramIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Instagram } from 'almanac-ui/icons'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import { InstagramInitialization } from 'components/IntegrationInitialization'

export const InstagramCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: InstagramIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  return (
    <ExternalIntegrationCard
      title={'Instagram Business'}
      description={'Post directly to your Instagram creator account or business page'}
      integrations={integrations}
      icon={<Instagram size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(InstagramInitialization)}
          provider={ExternalIntegrationEnum.Instagram}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
